// SQLite CHECK (json_valid(col)) detector.
// PRD: Ralph/JsonColumnSemantics/PRD.md § Slice A3.
//
// SQLite has no INFORMATION_SCHEMA; its CHECK constraints live inside the
// CREATE TABLE source preserved on `sqlite_master.sql`. The schema cache
// already loads that text into `SqliteSchemaObject.sql`, so detection is
// purely AST/regex over the cached source — no extra introspection round-trip
// is needed.
//
// Recognised forms (all case-insensitive):
//   CHECK (json_valid(col))
//   CHECK (json_valid(col) = 1)
//   CHECK (json_valid("col"))
//   CHECK (json_valid([col]))
//   CHECK (json_valid(`col`))
//
// The detector deliberately matches single-column json_valid checks only.
// Compound CHECKs (`json_valid(col) AND length(col) > 0`) are skipped per
// JCS-A3 acceptance ("Constraint must reference exactly one column;
// multi-column CHECKs ignored.") — extending later is a v2 candidate if
// users surface demand.

const JSON_VALID_CHECK = /CHECK\s*\(\s*json_valid\s*\(\s*([\w"`[\]]+)\s*\)(?:\s*=\s*1)?\s*\)/gi;

function unquoteIdentifier(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed.length < 2) return trimmed;
  const first = trimmed.charAt(0);
  const last = trimmed.charAt(trimmed.length - 1);
  if (first === '"' && last === '"') return trimmed.slice(1, -1).replace(/""/g, '"');
  if (first === '`' && last === '`') return trimmed.slice(1, -1).replace(/``/g, '`');
  if (first === '[' && last === ']') return trimmed.slice(1, -1);
  return trimmed;
}

export function detectSqliteJsonValidColumns(createTableSql: string | null | undefined): ReadonlySet<string> {
  if (!createTableSql) return EMPTY;
  const out = new Set<string>();
  let match: RegExpExecArray | null;
  JSON_VALID_CHECK.lastIndex = 0;
  while ((match = JSON_VALID_CHECK.exec(createTableSql)) !== null) {
    const raw = match[1];
    if (!raw) continue;
    const name = unquoteIdentifier(raw);
    if (name) out.add(name);
  }
  return out.size === 0 ? EMPTY : out;
}

const EMPTY: ReadonlySet<string> = new Set<string>();
